import React from 'react';

const Footer = () => {
	return (
		<footer className="bg-gray-900 text-white">
			<div className="lg:px-24 p-10 lg:py-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
				<div className="flex flex-col">
					<h3 className="text-xl font-bold mb-4">Contact the Publisher</h3>
					<p className="text-base leading-relaxed text-gray-400">
						info@ssevasadan.org
						<br />
						+91-8729-278439
					</p>
				</div>
				<div className="flex flex-col">
					<h3 className="text-xl font-bold mb-4">Explorate</h3>
					<p className="text-base text-gray-400">About</p>
					<p className="text-base text-gray-400">Partners</p>
					<p className="text-base text-gray-400">Blogs</p>
					<p className="text-base text-gray-400">Advertise</p>
					<p className="text-base text-gray-400">Membership</p>
				</div>
				<div className="flex flex-col">
					<h3 className="text-xl font-bold mb-4">Address</h3>
					<p className="text-base leading-relaxed text-gray-400">
						Thamma Cheruvukatta,
						<br />
						Manthani, Karimnagar Dist.,
						<br />
						Telangana – 505 184
					</p>
				</div>
				<div className="flex flex-col">
					<h3 className="text-xl font-bold mb-4">Connections</h3>
					<p className="text-base text-gray-400">facebook</p>
					<p className="text-base text-gray-400">twitter</p>
					<p className="text-base text-gray-400">youtube</p>
					<p className="text-base text-gray-400">pinterest</p>
					<p className="text-base text-gray-400">behance</p>
				</div>
			</div>
			<div className="bg-gray-800 lg:px-24 p-4 flex justify-between items-center text-white">
				<div>
					<p className="lg:text-base text-xs">2025 | SRI SEETHA RAMA SEVA SADAN</p>
				</div>
				<div>
					<a href="#subscribe" className="lg:text-base text-xs text-white hover:underline">Subscribe Now</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
